import { useState } from 'react';
import { useForm, Controller } from 'react-hook-form';
import { zodResolver } from '@hookform/resolvers/zod';
import { Lock, Eye, EyeOff } from 'lucide-react';

import { resetPasswordSchema } from '@/schemas/auth.schema';
import FormField from '@/pages/auth/components/FormField';
import { useResetPassword } from '@/hooks/useResetPassword';

import './Register.scss';
import { Button, Input } from 'antd';
import AuthLayout from '@/layouts/AuthLayout';

const ResetPassword = () => {
    const { loading, requestError, handleResetPassword } = useResetPassword();
    const [showPassword, setShowPassword] = useState(false);
    const [showConfirmPassword, setShowConfirmPassword] = useState(false);

    const {
        control,
        handleSubmit,
        formState: { errors },
    } = useForm({
        resolver: zodResolver(resetPasswordSchema),
        defaultValues: { password: '', confirmPassword: '' }
    });

    return (
        <AuthLayout>
            <h3>Reset Password</h3>
            <form onSubmit={handleSubmit(handleResetPassword)} noValidate>

                {requestError && (
                    <div className="form-error" role="alert">{requestError}</div>
                )}

                <FormField
                    label="New Password"
                    error={errors.password?.message}
                    icon={Lock}
                    rightElement={
                        <button type="button" className="field-icon-btn" onClick={() => setShowPassword(p => !p)}>
                            {showPassword ? <EyeOff size={15} /> : <Eye size={15} />}
                        </button>
                    }
                >
                    <Controller
                        name="password"
                        control={control}
                        render={({ field }) => (
                            <Input
                                {...field}
                                type={showPassword ? 'text' : 'password'}
                                placeholder="New password"
                                className="field-input"
                                autoComplete="new-password"
                                autoFocus
                            />
                        )}
                    />
                </FormField>

                <FormField
                    label="Confirm Password"
                    error={errors.confirmPassword?.message}
                    icon={Lock}
                    rightElement={
                        <button type="button" className="field-icon-btn" onClick={() => setShowConfirmPassword(p => !p)}>
                            {showConfirmPassword ? <EyeOff size={15} /> : <Eye size={15} />}
                        </button>
                    }
                >
                    <Controller
                        name="confirmPassword"
                        control={control}
                        render={({ field }) => (
                            <Input
                                {...field}
                                type={showConfirmPassword ? 'text' : 'password'}
                                placeholder="Confirm new password"
                                className="field-input"
                                autoComplete="new-password"
                            />
                        )}
                    />
                </FormField>

                <Button type="primary" htmlType='submit' className="auth-submit-btn" disabled={loading}>
                    {loading ? 'Saving...' : 'Set New Password'}
                </Button>

            </form>
        </AuthLayout>
    );
};

export default ResetPassword;
